import React from 'react';

import PropTypes from 'prop-types';
import {
  StyledToolbar,
  StyledToolbarActions,
  SearchBox,
  StyledToolbarSettings,
  StyledTableFiltersList,
} from './Toolbar.styles';
import { TableSettings } from './TableSettings';
import Filters from '../../TableFilters/components/Filters';
import TableFiltersList from '../../TableFiltersList';

export const Toolbar = ({
  toolbarActions,
  toolbarSearchField,
  toolbarFilters,
  toolbarFiltersList,
  hideTableSettings,
  hideFilters,
}) => (
  <>
    <StyledToolbar>
      <StyledToolbarActions>
        {toolbarActions}
        {/* Add conditions in future to enable / disable which elements need to be visible on particular table */}
      </StyledToolbarActions>
      <StyledToolbarSettings>
        {!hideFilters && <Filters>{toolbarFilters}</Filters>}
        {!hideTableSettings && <TableSettings />}
        {toolbarSearchField && <SearchBox>{toolbarSearchField()}</SearchBox>}
      </StyledToolbarSettings>
    </StyledToolbar>
    {toolbarFiltersList && (
      <StyledTableFiltersList>
        <TableFiltersList onReset={console.log}>
          {toolbarFiltersList}
        </TableFiltersList>
      </StyledTableFiltersList>
    )}
  </>
);

Toolbar.propTypes = {
  toolbarActions: PropTypes.array,
  toolbarSearchField: PropTypes.func,
  toolbarFilters: PropTypes.node,
  toolbarFiltersList: PropTypes.node,
  hideTableSettings: PropTypes.bool,
  hideFilters: PropTypes.bool,
};
